import { z } from 'zod';

export const WriteBackToAshbyConnectionMethod = z.object({
  type: z.literal('connection'),
});

export type WriteBackToAshbyConnectionMethod = z.infer<
  typeof WriteBackToAshbyConnectionMethod
>;

// A union of one member today; kept as a union shape (like the other
// providers' auth methods) so a `merge`/`api` method can be added later
// without a breaking schema change.
export const WriteBackToAshbyAuthMethod = WriteBackToAshbyConnectionMethod;

export type WriteBackToAshbyAuthMethod = z.infer<
  typeof WriteBackToAshbyAuthMethod
>;

export const WriteBackToAshbyCustomFieldPlaceToWrite = z.object({
  type: z.literal('customField'),
  fieldId: z.string(),
});

export type WriteBackToAshbyCustomFieldPlaceToWrite = z.infer<
  typeof WriteBackToAshbyCustomFieldPlaceToWrite
>;

export const WriteBackToAshbyPlaceToWrite =
  WriteBackToAshbyCustomFieldPlaceToWrite;

export type WriteBackToAshbyPlaceToWrite = z.infer<
  typeof WriteBackToAshbyPlaceToWrite
>;

export const WriteBackToAshbyStrategy = z.object({
  type: z.literal('ashby'),
  authMethod: WriteBackToAshbyAuthMethod.optional(),
  placesToWrite: z.array(WriteBackToAshbyPlaceToWrite).optional(),
});

export type WriteBackToAshbyStrategy = z.infer<typeof WriteBackToAshbyStrategy>;
